import Vue from "vue";
import Home from "./views/Home.vue";
import "./assets/css/main.css";

//rem适配
import "./assets/js/reset.js"
//公共引入 && 公共组件
import "./assets/js/common.js"

Vue.config.productionTip = false;

new Vue({
    render: h => h(Home)
}).$mount("#app");
